/**
 * Decline a request from wherever it is listed — Home's card, the bell — after
 * asking first. Owns the answer, so every place declines the same way. (D2)
 */
import type { MyPendingInvitation } from '@tonnie/sdk';

import { useShareRequestAnswer } from '../hooks/use-share-request-answer';
import { DeclineShareRequestDialog } from './DeclineShareRequestDialog';

export function ShareRequestDeclineConfirm({
  invitation,
  open,
  onOpenChange,
}: {
  invitation: Pick<MyPendingInvitation, 'token' | 'companyName'>;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const answer = useShareRequestAnswer(invitation.token, invitation.companyName);
  return (
    <DeclineShareRequestDialog
      company={invitation.companyName}
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={() => answer.decline(() => onOpenChange(false))}
    />
  );
}
